<h1 i18n="@@upp.families.air.search.title">Search Air Families</h1>

<section class="container-fluid">
  <ama-loading-alert [sendingStatus]="isLoading" message="Loading..." i18n-message="@@upp.global.messages.loading">
  </ama-loading-alert>
</section>

<ama-upp-notification
  class="col"
  [mainMessages]="searchNotificationMessages"
  [notification]="(notification$ | async)!"
  (closeNotificationEvent)="closeNotification()"
>
</ama-upp-notification>

<form class="styled-form" [formGroup]="airFamiliesSearchForm" (ngSubmit)="onSearchSubmit()">
  <section class="row">
    <div class="col text-end mb-2">
      <button
        i18n="@@upp.global.button.clear"
        type="button"
        [disabled]="isLoading"
        class="btn btn-outline-primary btn-sm"
        (click)="clearForm()"
        id="clear"
        >Clear
      </button>
    </div>
  </section>

  <section class="mb-4">
    <label i18n="@@upp.families.air.search.nameLabel" for="name" class="form-label">Name</label>
    <input
      type="text"
      class="form-control"
      id="name"
      data-test="air-family-name"
      [formControlName]="FormElements.NAME"
      [ngClass]="{ 'is-invalid': nameControl?.invalid && nameControl?.touched }"
      placeholder="Air family name"
      i18n-placeholder="@@upp.families.air.namePlaceholder"
      ngbTooltip="Enter the Air Family name with letters, numbers or spaces (up to 30 characters)"
      i18n-ngbTooltip="@@upp.families.air.nameTooltip"
      oninput="
        let p = this.selectionStart;
        this.value = this.value.toUpperCase();
        this.setSelectionRange(p, p);
      "
    />
    <ama-ng-upp-validation-error-message
      [control]="nameControl ?? undefined"
      [messageFunctions]="NAME_WITH_SPACES_VALIDATION_MESSAGES"
    >
    </ama-ng-upp-validation-error-message>

    <label class="form-label mt-5" [for]="FormElements.CARRIER_CODES" i18n="@@upp.global.criteria.carrierCode.label"
      >Carrier code</label
    >
    <ama-ng-upp-lookup-select
      [formControlName]="FormElements.CARRIER_CODES"
      [multiple]="true"
      id="carrierCodes"
      [addTag]="true"
      notFoundText="No airlines found"
      i18n-notFoundText="@@upp.global.criteria.carrierCode.notFoundText"
    >
    </ama-ng-upp-lookup-select>
    <ama-ng-upp-validation-error-message
      [control]="airFamiliesSearchForm.get(FormElements.CARRIER_CODES) ?? undefined"
      [messageFunctions]="TWO_SYMBOLS_REQUIRED"
    >
    </ama-ng-upp-validation-error-message>
  </section>

  <section class="d-flex justify-content-center mt-8">
    <button
      i18n="@@upp.global.button.search"
      id="search"
      type="submit"
      class="btn btn-primary btn-action mb-2 mb-md-0 me-2"
      [disabled]="airFamiliesSearchForm.invalid || isLoading"
    >
      Search
    </button>
  </section>
</form>

@if (!agGridTablesActivated) {
  <ama-ng-upp-basic-search-result-table
    [searchResults]="(airFamilies$ | async) ?? undefined"
    [selectedNames]="(selectedAirFamilyNames$ | async) ?? undefined"
    [sendingStatus]="isLoading"
    [sourceComponent]="UppComponentNames.AIR_FAMILIES"
    [entryType]="EntryType.AIR_FAMILY"
    [recordToSearchResult]="recordToSearchResult.bind(this)"
    [entryToUpdateCreator]="entryToUpdateCreator"
    [entryToUpdateNameResolver]="entryToUpdateNameResolver"
    (deleteEntry)="deleteAirFamily($any($event))"
    (clearTableEvent)="clearAirFamilies()"
    [managePermission]="PERMISSION_MANAGE_FAMILY"
    [displayableFields]="displayableFields"
    [isLookup]="lookup"
    [lookupValues]="lookupValues"
    [lookupOptions]="lookupOptions"
    (showDetail)="showAirFamily($event, UppViewNames.DISPLAY)"
    (modifyDetail)="showAirFamily($event, UppViewNames.MODIFY)"
    [copyForbidden]="true"
  >
  </ama-ng-upp-basic-search-result-table>
} @else {
  @if (lookup) {
    <div class="mt-3 mb-3">
      <button class="btn btn-link me-auto p-2" (click)="goBack()">
        <span class="fa-angle-left df-icon-wtd me-2"></span>
        {{ goBackLinkText }}
      </button>
    </div>
  }
  <div class="row mt-7">
    <div id="search-result" class="col">
      <div class="ag-theme-alpine grid-container">
        <ag-grid-angular
          [rowData]="(transformedAirFamilies$ | async) ?? []"
          [columnDefs]="columnDefs"
          [gridOptions]="gridOptions"
          [defaultColDef]="defaultColDef"
          (gridReady)="onGridReady($event)"
          class="grid-component"
        ></ag-grid-angular>
      </div>
    </div>
  </div>
}
